// actions.js
const CALDR_SUCCESS = 'CALDR_SUCCESS';
const caldrSuccess = (data) => ({ type: CALDR_SUCCESS, payload: data });
const initialState = {
    apiValues: "ApiCall",
};

const apiCalendarReducer = (state = initialState, action) => {
    switch (action.type) {
        case CALDR_SUCCESS:
            return {
                ...state,
                apiValues: action.payload,
            };
        default:
            return state;
    }
};

export { apiCalendarReducer, caldrSuccess, }
